import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ClerkProvider } from "@clerk/clerk-react"
import { App } from "./App"
import "./index.css"

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined

const rootEl = document.getElementById("root")
if (!rootEl) throw new Error("root element not found")

if (!PUBLISHABLE_KEY) {
  // Render a useful error in dev when Clerk isn't configured. Production will
  // always have the key (set via Cloudflare Pages env vars).
  createRoot(rootEl).render(
    <div style={{ padding: 32, fontFamily: "Inter, sans-serif" }}>
      <h2 style={{ color: "#b91c1c" }}>VITE_CLERK_PUBLISHABLE_KEY missing</h2>
      <p>Add it to <code>.env.local</code> (see <code>.env.example</code>).</p>
    </div>,
  )
} else {
  createRoot(rootEl).render(
    <StrictMode>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        signInFallbackRedirectUrl="/signup"
        signUpFallbackRedirectUrl="/signup"
      >
        <App />
      </ClerkProvider>
    </StrictMode>,
  )
}
